<script setup lang="ts">
// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()
</script>

<template>
  <div></div>
</template>
